import { render, staticRenderFns } from "./v-attachment-item.vue?vue&type=template&id=6a09d0a3"
import script from "./v-attachment-item.vue?vue&type=script&lang=js"
export * from "./v-attachment-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports